import { popupWindow } from '../shared/utils/window.helper';

// Port of src/app/services/social-sharing.service.ts (stateless service →
// exported functions).

export type SocialShareTarget = 'facebook' | 'twitter' | 'linkedin' | 'whatsapp';
export type SocialShareSource = 'playlist' | 'song' | 'search' | 'affiliate link';

export function shareOnSocial(url: string,
                              shareTo: SocialShareTarget,
                              source: SocialShareSource): void {
  const text = createSocialText(source);

  switch (shareTo) {
    case 'facebook':
      shareOnFacebook(url);
      break;
    case 'linkedin':
      shareOnLinkedin(url, 'Songhunt and MyPart', 'Look at what I found', 'Songhunt.ai');
      break;
    case 'twitter':
      shareOnTwitter(url, text, []);
      break;
    case 'whatsapp':
      shareOnWhatsapp(url, text);
      break;
  }
}

export function createSocialText(source: SocialShareSource): string {
  switch (source) {
    case 'playlist':
      return 'Check out this playlist I created with Songhunt.ai!';
    case 'song':
      return 'Check out this song I discovered using Songhunt.ai!';
    case 'search':
      return 'Check out this song search I ran using Songhunt.ai!';
    case 'affiliate link':
      return 'Get 50% off Songhunt Premium! Sign up with my link and discover new music with AI-powered song search and playlisting.';
  }
}

function shareOnFacebook(url: string) {
  const encodedURL = encodeURIComponent(url);
  const facebookURL = `https://www.facebook.com/sharer/sharer.php?u=${encodedURL}`;

  openShareWindow(facebookURL);
}

function shareOnTwitter(url: string, text: string, hashtags: string[]) {
  const encodedURL = encodeURIComponent(url);
  const encodedText = encodeURIComponent(text);
  const encodedHashtags = encodeURIComponent(hashtags.join(','));

  const twitterURL = `https://twitter.com/intent/tweet?url=${encodedURL}&text=${encodedText}&hashtags=${encodedHashtags}`;

  openShareWindow(twitterURL);
}

function shareOnLinkedin(url: string, title: string, summary: string, source: string) {
  const encodedLink = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  const encodedSummary = encodeURIComponent(summary);
  const encodedSource = encodeURIComponent(source);

  const linkedInURL = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedLink}&title=${encodedTitle}&summary=${encodedSummary}&source=${encodedSource}`;

  openShareWindow(linkedInURL);
}

function shareOnWhatsapp(url: string, text: string) {
  const encodedLink = encodeURIComponent(`${text} - ${url}`);
  const whatsappURL = `https://api.whatsapp.com/send?text=${encodedLink}`;
  openShareWindow(whatsappURL);
}

function openShareWindow(url: string) {
  popupWindow(url, 'MyPart Songhunt', 640, 480);
}
